import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { paths } from '@/config/path'
import { useAuthenticatedUser } from '@/state/session'

export const useOnboardingGuard = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const user = useAuthenticatedUser()

  const isTechnician = user.profile.profile === 'technician'
  const isOnboardingCompleted = user.profile.onboarding_completed ?? false
  const needsOnboarding = isTechnician && !isOnboardingCompleted

  const pathname = location.pathname
  const isOnOnboardingPage = pathname === paths.onboarding.getHref()

  useEffect(() => {
    // If technician needs onboarding and is not on onboarding page, redirect to onboarding
    if (needsOnboarding && !isOnOnboardingPage) {
      navigate(paths.onboarding.getHref(), { replace: true })
      return
    }

    // If technician has completed onboarding and is on onboarding page, redirect to orders page
    if (isTechnician && isOnboardingCompleted && isOnOnboardingPage) {
      navigate(paths.app.orders.getHref(), { replace: true })
      return
    }
  }, [pathname, navigate, needsOnboarding, isOnOnboardingPage, isTechnician, isOnboardingCompleted])

  return useMemo(
    () => ({
      needsOnboarding,
      isOnboardingCompleted,
      isTechnician,
      isOnOnboardingPage,
    }),
    [needsOnboarding, isOnboardingCompleted, isTechnician, isOnOnboardingPage],
  )
}
